module.exports = __webpack_public_path__ + "img/shebei1.f46a50a8.png";